import isNode from '../ajio-util/isNode';

let proxyAgent;
if (isNode()) {
  const tunnel = require('tunnel2');
  proxyAgent = tunnel.httpsOverHttp({
    proxy: {
      host: 'http://lwproxy.jio.com',
      port: '8080'
    }
  });
}
module.exports = {
  endpoints: {
    category: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    categoryV4: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v4/rilfnl/products/category'
    },
    categoryV5: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v5/rilfnl/products/category'
    },
    categoryV6: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v6/rilfnl/products/category'
    },
    categoryV7: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v7/rilfnl/products/category'
    },
    personalisedCategory: {
      href: 'http://gcprep-sf.services.ajio.jio.com/searchservices/v1/rilfnl/personalized/products/category'
    },
    capsulecp: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    topSearches: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'http://pdpaggregator.gcprep-ajio.jio.com/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://pdpaggregator.gcprep-ajio.jio.com/aggregator/pdp/serviceability'
    },
    curatedPage: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    searchV4: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v4/rilfnl/products/search'
    },
    searchV5: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v5/rilfnl/products/search'
    },
    searchV6: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v6/rilfnl/products/search'
    },
    searchV7: {
      href: 'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v7/rilfnl/products/search'
    },
    newdesignhomepage: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://rep-services.ajio.jio.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://rep-services.ajio.jio.com/storefront/cms/component'
    },
    runtimeLocale: {
      href: 'http://rep-services.ajio.jio.com/storefront/cms/locale'
    },
    runtimeNavigationDesktop: {
      href: 'http://rep-services.ajio.jio.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://gcprep-cms.services.ajio.jio.com/cms/v1/navigation/preview'
    },
    landingPageRuntimePreview: {
      href: 'http://gcprep-cms.services.ajio.jio.com/cms/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://gcprep-cms.services.ajio.jio.com/cms/v1/page/archive'
    },
    newcategoryselection: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href:
        'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    navigationmobile: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    minicart: {
      href: 'http://gcprep-sf.services.ajio.jio.com/cart/rollover/json/MiniCart'
    },
    wishlist: {
      href: 'http://gcprep-sf.services.ajio.jio.com/addToWishlistAjax'
    },
    leaderBoard: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/oauth/token'
    },
    generateLoginOTP: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signInSocial: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    selfcareInitChat: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    selfcarefaq: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href:
        'http://gcprep-search.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    setNewPassword: {
      href:
        'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://rep-services.ajio.jio.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href:
        'https://gcprep-cms.services.ajio.jio.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href:
        'http://gcprep-sizechart.services.ajio.jio.com/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://gcprep-sizechart.services.ajio.jio.com/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://gcprep-sizechart.services.ajio.jio.com/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://gcprep-sizechart.services.ajio.jio.com/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://assets.gcprep-ajio.jio.com/snoop/kioskIPWhitelist.json'
    },
    roadblock: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    submitAssistantId: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    signUpKiosk: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    kioskEntryPage: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'http://identity.gcprep-ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href:
        'http://pdpaggregator.gcprep-ajio.jio.com/aggregator/edd/checkDeliveryDetails'
    },
    checkServiceableCart: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    flashSaleApiUrl: {
      href: 'http://flashsale.gcprep-ajio.jio.com/flashsale'
    },
    flashSaleUrl: {
      href: 'https://gcprep-flashsale.services.ajio.jio.com/flashsale'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment.gcprep-ajio.jio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    uaasLoginToken: {
      href: 'http://uaasrep.ajio.com/uaas/jwt/token/client'
    },
    uaasAccountCheck: {
      href: 'http://uaasrep.ajio.com/uaas/accountCheck'
    },
    uaasGetProfile: {
      href: 'http://uaasrep.ajio.com/uaas/users/current'
    },
    uaasGenerateLoginOtp: {
      href: 'http://uaasrep.ajio.com/uaas/login/sendOTP'
    },
    uaasSessionClear: {
      href: 'http://uaasrep.ajio.com/uaas/users'
    },
    uaasSignupAndSocial: {
      href: 'http://uaasrep.ajio.com/uaas/registerUser'
    },
    uaasSignupAndSocialNewDesign: {
      href: 'http://uaasrep.ajio.com/uaas/newAppRegisterUser'
    },
    uaasSignInSocial: {
      href: 'http://uaasrep.ajio.com/uaas/login/socialLogin'
    },
    uaasUpdateUserDetails: {
      href: 'http://uaasrep.ajio.com/uaas/users/updateUser/details'
    },
    uaasRefreshToken: {
      href: 'http://uaasrep.ajio.com/uaas/jwt/token/refresh'
    },
    uaasLogin: {
      href: 'http://uaasrep.ajio.com/uaas/login'
    },
    uaasMyJioLogin: {
      href: 'http://uaasrep.ajio.com/uaas/myjio/login'
    },
    uaasGetUserInfo: {
      href: 'http://uaasrep.ajio.com/uaas/users/getUserProfileByEmailId'
    },
    uaasUserInfoOtp: {
      href: 'http://uaasrep.ajio.com/uaas/users/editaddress'
    },
    uaasEmailUpdateOtp: {
      href: 'http://uaasrep.ajio.com/uaas/update/sendOTP'
    },
    uaasEmailVerifyOtp: {
      href: 'http://uaasrep.ajio.com/uaas/update/verifyOTP'
    },
    uaasMobileUpdate: {
      href: 'http://uaasrep.ajio.com/uaas/users/update/mobileNumber/request'
    },
    uaasMobileUpdateCancel: {
      href: 'http://uaasrep.ajio.com/uaas/users/updateMobileNumber/cancel'
    },
    uassGenerateVerifyOtp: {
      href: 'http://uaasrep.ajio.com/uaas/update/sendOTP'
    },
    uassVerifyMobileNumberOtp: {
      href: 'http://uaasrep.ajio.com/uaas/update'
    },
    uassFetchEmailByUrl: {
      href: 'http://uaasrep.ajio.com/uaas/fetchEmailByURL'
    },
    generateCaptchaMobileRestore: {
      href: 'http://uaasrep.ajio.com/uaas/generate/captcha'
    },
    generateEmailForRestoreMobile: {
      href: 'http://uaasrep.ajio.com/uaas/mobileUpdate/generateEmail'
    },
    fetchBankTransferStatus: {
      href: 'https://payment.gcprep-ajio.jio.com/payment-engine/api/v1/refund/bank-transfer-status'
    },
    uaasVerfiyEmailInfo: {
      href: 'http://uaasrep.ajio.com/uaas/users/verifyEmail'
    },
    jioBannerAdsListing: {
      href: 'https://mercuryads.jio.com/delivery/mapi.php'
    },
    fleekExploreBrands: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/rilfnlwebservices/v1/rilfnl/brands'
    },
    fleekExplore: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/common-aggregator/users/uuid/brands/explore'
    },
    fleekFeed: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/feed-engine/v1/feed'
    },
    fleekFeedPreview: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/feed-engine/v1/feed/preview'
    },
    fleekSesPostSeen: {
      href: 'https://rep-ajiogram-internal.services.jio.com:31807/ses/v1/content/seen'
    },
    fleekBrandFollow: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/ses/v1/brand/action/'
    },
    fleekSesPostLike: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/ses/v1/content/action/'
    },
    fleekPostShare: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/ses/v1/content/share/'
    },
    fleekBrandPage: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/common-aggregator/users/uuid/brand'
    },
    fleekIndividualPost: {
      href: 'http://rep-ajiogram-internal.services.jio.com:31807/feed-engine/v1/getPost'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaasrep.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV3: {
      href: 'http://uaas-gcp.ajio.com/uaas/v3/rilfnl/users/customertype?service=&store=STORE_NAME'
    },
    customerTypeUAASV4: {
      href: 'http://uaas-gcp.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://gcprep-sf.services.ajio.jio.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaasrep.ajio.com/uaas/users/verifyTaxPayerId'
    }, 
    deviceLevelCohort: {
      href:
        'http://rep-services.ajio.jio.com/service/am/runtime/cohort/getUserSegmentAndCohort/device/'
    },
    deviceLevelCohortV2: {
      href:
        'http://rep-services.ajio.jio.com/service/am/runtime/v2/cohort/getUserSegmentAndCohort/device/'
    },
    deviceLevelCohortV3: {
      href:
        'http://rep-services.ajio.jio.com/service/am/runtime/v3/cohort/getUserSegmentAndCohort/device/'
    },
    accountDelete: {
      href: 'http://uaasrep.ajio.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    rushAvailabilityCall: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/v1/deliveryType/availability'
    },
    membershipDetails: {
      href: 'http://api-internal.ajioreplica.jio.com/membership/runtime'
    },
    recommendationWidget: {
      href:
        'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/recommendation/v1/widget/config'
    },
    jioAdsSapiApi: {
      href: 'https://mercuryads.jio.com/delivery/sapi.php'
    },
    productDeliveryTypeRush: {
      href: 'http://pdpaggregator.gcprep-ajio.jio.com/aggregator/pdp/deliveryType'
    },
    uaasB2BUsers: {
      href: 'http://uaasrep.ajio.com/uaas/b2b/users'
    },
    recommendationWidgetOsmos: {
      href: 'http://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    },
    recommendationTrendsVibes: {
      href: 'https://gcprep-sf.services.ajio.jio.com/rilfnlwebservices/recommendation/v1/trends'
    },
  },
  properties: {
    version: '01.03.00',
    environment: 'PRODUCTION_GCP_REPLICA',
    siteUrl: 'https://gcprep-ajio.jio.com',
    parentUrl: 'https://gcprep-ajio.jio.com',
    baseImgUrl: 'https://assets.gcprep-ajio.jio.com',
    assetUrl: 'https://assets.gcprep-ajio.jio.com',
    imageBaseUrl: 'https://assets.gcprep-ajio.jio.com',
    apiUrl: 'http://gcprep-sf.services.ajio.jio.com',
    gamificationApiUrl: 'http://rep-services.ajio.jio.com/gamification',
    paymentURL: 'https://payment.gcprep-ajio.jio.com',
    cartUrl: 'http://gcprep-sf.services.ajio.jio.com',
    wishlistUrl: 'http://gcprep-wishlist.services.ajio.jio.com',
    luxeURL: 'https://luxe.gcprep-ajio.jio.com',
    streetURL: 'https://street.gcprep-ajio.jio.com',
    fleekURL: 'https://rep-ajiogram.ajio.jio.com',
    luxeGoogleUrl: 'https://luxe.gcprep-ajio.jio.com',
    loginPageURL: 'https://login.gcprep-ajio.jio.com',
    pAPI: 'https://payment.gcprep-ajio.jio.com',
    npeBaseUrl: 'http://gcprep-runtime-promoengine.services.ajio.jio.com',
    cemUrl: 'https://gcprep-ajio.jio.com/cem',
    previewCheck: false,
    gtmCode: '5XMX63',
    optimizeID: 'OPT-KTLN3ZV',
    GAID: 'UA-68002030-3',
    APIErrorGAID: 'UA-68002030-3',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    dataGrinchAppKey: 'app5b30be1f0e5bf814621703f9',
    rumMOKey: 'c58a39eb46bfd43b62704a0ecf8d6fd8',
    pe: 'ON', // "OFF" for turning OFF
    timeout: 25000,
    timeoutNode: 30000,
    timeoutClient: 40000,
    dropAtStore: 'ON',
    gpayAppticker: 'ON', // ON = hide, OFF = show
    gpayRoadBlock: 'ON', // ON = hide, OFF = show
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'OFF',
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    downloadInvoiceFlag: true,
    cleverTapID: '48K-4R4-K84Z',
    sizeSenseConfig: {
      environment: 'replica',
      accessToken: '99981f9a55f024da7afd744bf166512660a91bd13c062756f1877c9966049d04',
    },
    firebaseConfig: JSON.stringify({
 
    }),
    firebaseConfig_M: JSON.stringify({
  
    }),
    jioBannerAdsListingAdspotId: '6yazm3k1',
    webAppVersion: '1.0.0',
    segment_api_write_key : 'hKdcCBW9TrvuhEehZTBSSaJLGNhLRasy',
    copilotURL: 'https://script.copilot.live/v1/copilot.min.js?tkn=cat-6cvtdddi',
    amplitude_experiment_server_key: 'server-BAiZpqGTQh9PTJOXoTaWQPp05YL1GiO0',
    ajioLoyaltyServiceUrl: 'https://preprod-ajio-gw.api.engageapps.jio',
    botifyWebsiteId: 'UO4YE7'
  }
};